"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _dataModel = require("@rdfjs/data-model");

var _ComunicaUpdateEngine = _interopRequireDefault(require("./ComunicaUpdateEngine"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * LDflex property resolver that returns a new path
 * starting from the property name as a subject.
 *
 * For example, when triggered as
 *     data['http://person.example/#me'].friends.firstName
 * it will create a path with `http://person.example/#me` as subject
 * and then resolve `friends` and `firstName` against the JSON-LD context.
 *
 * In case a source object is given as input, data will be pulled from there.
 */


var SubjectPathResolver =
/*#__PURE__*/
function () {
  function SubjectPathResolver(pathFactory, source) {
    _classCallCheck(this, SubjectPathResolver);

    this._paths = pathFactory;
    this._source = source;
  }
  /** Resolve all string properties (not Symbols) */


  _createClass(SubjectPathResolver, [{
    key: "supports",
    value: function supports(property) {
      return typeof property === 'string';
    }
  }, {
    key: "resolve",
    value: function resolve(property) {
      return this._createSubjectPath((0, _dataModel.namedNode)(property));
    }
  }, {
    key: "_createSubjectPath",
    value: function _createSubjectPath(subject) {
      var source = this._source || Promise.resolve(subject).catch(function () {
        return null;
      });
      var queryEngine = new _ComunicaUpdateEngine.default(source);
      return this._paths.create({
        queryEngine: queryEngine
      }, {
        subject: subject
      });
    }
  }]);

  return SubjectPathResolver;
}();

exports.default = SubjectPathResolver;